/**
 * Serviço de despesas fixas recorrentes
 */

import api from './api';

export const listarDespesasRecorrentes = async () => {
  const response = await api.get('/despesas-recorrentes');
  return response;
};

export const criarDespesaRecorrente = async (dados) => {
  const response = await api.post('/despesas-recorrentes', dados);
  return response;
};

export const cancelarDespesaRecorrente = async (id) => {
  const response = await api.patch(`/despesas-recorrentes/${id}/cancelar`);
  return response;
};
